var exports = {
  "S": "counterSkeleton__nihr6M",
};

module.exports = exports;
